import { Row, Col, Switch, Input, Divider } from 'antd';
import { BaseSelect } from 'components/Elements';
import ShipmentRateTable from 'components/ShipmentRateTable';

const StorefrontNonClassificationSettingForm = (props) => {
    const { platform, data, onChange } = props;

    return (
        <div>
            {/* <ShipmentRateTable
                {...props}
                data={data?.non_classify_rate?.rate || {}}
                prefix={`${platform}.storefront.non_classify_rate`}
            />
            <Divider /> */}
            <Row gutter={[16, 16]} className="mb-16">
                <Col xs={24} sm={24} md={24} lg={24}>
                    <div className='mb-8'>Add handling charges</div>

                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24} md={12} lg={12}>
                            <BaseSelect
                                className='w-100'
                                placeholder="Mode"
                                options={[
                                    { value: 'fixed', label: 'Fixed' },
                                    { value: 'percentage', label: 'Percentage' },
                                ]}
                                value={data?.non_classify_rate?.handling_charges_mode}
                                onChange={(value) => onChange(`${platform}.storefront.non_classify_rate.handling_charges_mode`, value)}
                            />
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12}>
                            <Input
                                placeholder="Percent charge"
                                value={data?.non_classify_rate?.handling_charges}
                                onChange={(e) => onChange(`${platform}.storefront.non_classify_rate.handling_charges`, e.target.value)}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <div className='mb-16'>
                <div>
                    <span className='mr-16'>Add markup over live rates</span>
                    <Switch
                        size='small'
                        checked={data?.non_classify_rate?.enable_markup_over_live_rates}
                        onChange={(checked) => onChange(`${platform}.storefront.non_classify_rate.enable_markup_over_live_rates`, checked)}
                    />
                </div>
                <Row gutter={[16, 16]} className="mt-8">
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <BaseSelect
                            className='w-100'
                            placeholder="Mode"
                            options={[
                                { value: 'fixed', label: 'Fixed' },
                                { value: 'percentage', label: 'Percentage' },
                            ]}
                            value={data?.non_classify_rate?.markup_mode}
                            onChange={(value) => onChange(`${platform}.storefront.non_classify_rate.markup_mode`, value)}
                        />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <Input
                            value={data?.non_classify_rate?.markup_value}
                            onChange={(e) => onChange(`${platform}.storefront.non_classify_rate.markup_value`, e.target.value)}
                            placeholder="Markup value"
                        />
                    </Col>
                </Row>
            </div>
        </div>
    )
};

export default StorefrontNonClassificationSettingForm;
